import React from 'react';
// Mock data for Vital Statistics Report
export const mockVitalStatisticsData = {
  totalBirths: 24583,
  totalDeaths: 18742,
  totalMarriages: 12350,
  birthsDeathsOverTime: [{
    month: 'Jan',
    births: 2100,
    deaths: 1600
  }, {
    month: 'Feb',
    births: 1950,
    deaths: 1550
  }, {
    month: 'Mar',
    births: 2050,
    deaths: 1500
  }, {
    month: 'Apr',
    births: 2200,
    deaths: 1450
  }, {
    month: 'May',
    births: 2150,
    deaths: 1500
  }, {
    month: 'Jun',
    births: 2050,
    deaths: 1550
  }, {
    month: 'Jul',
    births: 2000,
    deaths: 1600
  }, {
    month: 'Aug',
    births: 2100,
    deaths: 1650
  }, {
    month: 'Sep',
    births: 2050,
    deaths: 1600
  }, {
    month: 'Oct',
    births: 1950,
    deaths: 1650
  }, {
    month: 'Nov',
    births: 1900,
    deaths: 1700
  }, {
    month: 'Dec',
    births: 2080,
    deaths: 1750
  }],
  marriagesByJurisdiction: [{
    jurisdiction: 'Central District',
    marriages: 2450
  }, {
    jurisdiction: 'Northern Region',
    marriages: 1850
  }, {
    jurisdiction: 'Eastern Province',
    marriages: 2100
  }, {
    jurisdiction: 'Western Zone',
    marriages: 2350
  }, {
    jurisdiction: 'Southern District',
    marriages: 1950
  }, {
    jurisdiction: 'Metropolitan Area',
    marriages: 1650
  }],
  demographicData: [{
    ageGroup: '0-4',
    male: 1200,
    female: 1150
  }, {
    ageGroup: '5-9',
    male: 1150,
    female: 1100
  }, {
    ageGroup: '10-14',
    male: 1100,
    female: 1050
  }, {
    ageGroup: '15-19',
    male: 1050,
    female: 1000
  }, {
    ageGroup: '20-24',
    male: 1000,
    female: 950
  }, {
    ageGroup: '25-29',
    male: 950,
    female: 900
  }, {
    ageGroup: '30-34',
    male: 900,
    female: 850
  }, {
    ageGroup: '35-39',
    male: 850,
    female: 800
  }, {
    ageGroup: '40-44',
    male: 800,
    female: 750
  }, {
    ageGroup: '45-49',
    male: 750,
    female: 700
  }, {
    ageGroup: '50-54',
    male: 700,
    female: 650
  }, {
    ageGroup: '55-59',
    male: 650,
    female: 600
  }, {
    ageGroup: '60-64',
    male: 600,
    female: 550
  }, {
    ageGroup: '65-69',
    male: 550,
    female: 500
  }, {
    ageGroup: '70-74',
    male: 500,
    female: 450
  }, {
    ageGroup: '75-79',
    male: 450,
    female: 400
  }, {
    ageGroup: '80+',
    male: 400,
    female: 350
  }]
};
export const mockVitalRecords = Array.from({
  length: 100
}, (_, i) => {
  const recordTypes = ['Birth', 'Death', 'Marriage'];
  const jurisdictions = ['Central District', 'Northern Region', 'Eastern Province', 'Western Zone', 'Southern District', 'Metropolitan Area'];
  const genders = ['Male', 'Female'];
  const recordType = recordTypes[Math.floor(Math.random() * recordTypes.length)];
  const year = 2023;
  const month = Math.floor(Math.random() * 12) + 1;
  const day = Math.floor(Math.random() * 28) + 1;
  return {
    id: `REC-${100000 + i}`,
    recordType,
    date: `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
    jurisdiction: jurisdictions[Math.floor(Math.random() * jurisdictions.length)],
    gender: genders[Math.floor(Math.random() * genders.length)],
    age: recordType === 'Birth' ? 0 : Math.floor(Math.random() * 90) + 1
  };
});
// Mock data for Traffic Offenses Report
export const mockTrafficData = {
  totalOffenses: 8756,
  totalFines: 1245750,
  collectionRate: 68,
  offenseHotspots: [{
    region: 'Downtown',
    count: 245,
    latitude: 40.7128,
    longitude: -74.006
  }, {
    region: 'North End',
    count: 189,
    latitude: 42.3601,
    longitude: -71.0589
  }, {
    region: 'Westside',
    count: 156,
    latitude: 34.0522,
    longitude: -118.2437
  }, {
    region: 'Harbor District',
    count: 212,
    latitude: 32.7157,
    longitude: -117.1611
  }, {
    region: 'Eastville',
    count: 178,
    latitude: 39.9526,
    longitude: -75.1652
  }, {
    region: 'South County',
    count: 134,
    latitude: 37.7749,
    longitude: -122.4194
  }, {
    region: 'Central Business District',
    count: 267,
    latitude: 41.8781,
    longitude: -87.6298
  }, {
    region: 'University Area',
    count: 145,
    latitude: 35.9132,
    longitude: -79.0558
  }],
  topOffenses: [{
    offense: 'Speeding',
    count: 2450
  }, {
    offense: 'Running Red Light',
    count: 1850
  }, {
    offense: 'Illegal Parking',
    count: 1350
  }, {
    offense: 'Driving Without License',
    count: 950
  }, {
    offense: 'Using Phone While Driving',
    count: 850
  }, {
    offense: 'Driving Under Influence',
    count: 650
  }, {
    offense: 'Improper Lane Change',
    count: 450
  }, {
    offense: 'No Insurance',
    count: 350
  }, {
    offense: 'Expired Registration',
    count: 300
  }, {
    offense: 'Seat Belt Violation',
    count: 250
  }],
  finesOverTime: [{
    month: 'Jan',
    amount: 95000,
    count: 750
  }, {
    month: 'Feb',
    amount: 88000,
    count: 690
  }, {
    month: 'Mar',
    amount: 92000,
    count: 720
  }, {
    month: 'Apr',
    amount: 105000,
    count: 800
  }, {
    month: 'May',
    amount: 110000,
    count: 850
  }, {
    month: 'Jun',
    amount: 115000,
    count: 900
  }, {
    month: 'Jul',
    amount: 120000,
    count: 920
  }, {
    month: 'Aug',
    amount: 118000,
    count: 910
  }, {
    month: 'Sep',
    amount: 112000,
    count: 880
  }, {
    month: 'Oct',
    amount: 105000,
    count: 820
  }, {
    month: 'Nov',
    amount: 98000,
    count: 760
  }, {
    month: 'Dec',
    amount: 90000,
    count: 700
  }],
  paymentStatus: [{
    name: 'Paid',
    value: 5950
  }, {
    name: 'Overdue',
    value: 1850
  }, {
    name: 'Appealed',
    value: 956
  }]
};
export const mockTrafficFines = Array.from({
  length: 100
}, (_, i) => {
  const offenses = ['Speeding', 'Running Red Light', 'Illegal Parking', 'Driving Without License', 'Using Phone While Driving', 'Driving Under Influence', 'Improper Lane Change', 'No Insurance', 'Expired Registration', 'Seat Belt Violation'];
  const locations = ['Main St & 5th Ave', 'Broadway & 42nd St', 'Highway 101 Mile 24', 'Central Park West', 'Market St & 3rd Ave', 'Ocean Blvd & Beach Dr', 'University Ave', 'Downtown Transit Center', 'Industrial Pkwy', 'Mall Parking Lot'];
  const statuses = ['Paid', 'Overdue', 'Appealed'];
  const offense = offenses[Math.floor(Math.random() * offenses.length)];
  const amount = Math.floor(Math.random() * 300) + 50;
  const year = 2023;
  const month = Math.floor(Math.random() * 12) + 1;
  const day = Math.floor(Math.random() * 28) + 1;
  return {
    refNo: `TF-${100000 + i}`,
    offenseDescription: offense,
    date: `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`,
    location: locations[Math.floor(Math.random() * locations.length)],
    plateNo: `${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}-${Math.floor(Math.random() * 10000).toString().padStart(4, '0')}`,
    amount: `$${amount}`,
    status: statuses[Math.floor(Math.random() * statuses.length)]
  };
});
// Mock data for Property Tax Report
export const mockPropertyTaxData = {
  totalProperties: 45672,
  totalAssessedValue: 8750000000,
  totalTaxAssessed: 105000000,
  totalTaxCollected: 89250000,
  delinquencyRate: 15,
  taxCollectedVsAssessed: [{
    jurisdiction: 'Central District',
    assessed: 25000000,
    collected: 22500000
  }, {
    jurisdiction: 'Northern Region',
    assessed: 18000000,
    collected: 14400000
  }, {
    jurisdiction: 'Eastern Province',
    assessed: 15000000,
    collected: 12750000
  }, {
    jurisdiction: 'Western Zone',
    assessed: 22000000,
    collected: 19800000
  }, {
    jurisdiction: 'Southern District',
    assessed: 12000000,
    collected: 9600000
  }, {
    jurisdiction: 'Metropolitan Area',
    assessed: 13000000,
    collected: 10200000
  }],
  collectionRateByPropertyType: [{
    propertyType: 'Residential',
    rate: 88
  }, {
    propertyType: 'Commercial',
    rate: 92
  }, {
    propertyType: 'Industrial',
    rate: 95
  }, {
    propertyType: 'Agricultural',
    rate: 78
  }, {
    propertyType: 'Vacant Land',
    rate: 65
  }],
  monthlyCollectionTrends: [{
    month: 'Jan',
    amount: 12500000
  }, {
    month: 'Feb',
    amount: 9800000
  }, {
    month: 'Mar',
    amount: 8500000
  }, {
    month: 'Apr',
    amount: 7200000
  }, {
    month: 'May',
    amount: 6500000
  }, {
    month: 'Jun',
    amount: 5800000
  }, {
    month: 'Jul',
    amount: 7200000
  }, {
    month: 'Aug',
    amount: 6800000
  }, {
    month: 'Sep',
    amount: 6200000
  }, {
    month: 'Oct',
    amount: 5900000
  }, {
    month: 'Nov',
    amount: 6500000
  }, {
    month: 'Dec',
    amount: 7250000
  }]
};
export const mockPropertyTaxRoll = Array.from({
  length: 100
}, (_, i) => {
  const propertyTypes = ['Residential', 'Commercial', 'Industrial', 'Agricultural', 'Vacant Land'];
  const jurisdictions = ['Central District', 'Northern Region', 'Eastern Province', 'Western Zone', 'Southern District', 'Metropolitan Area'];
  const statuses = ['Paid in Full', 'Partially Paid', 'Unpaid', 'Delinquent', 'In Appeal'];
  const assessedValue = Math.floor(Math.random() * 900000) + 100000;
  const taxRate = 0.012; // 1.2%
  const taxDue = Math.round(assessedValue * taxRate);
  const amountPaid = Math.round(taxDue * (Math.random() * 1.05)); // Some might overpay slightly
  const outstandingBalance = Math.max(0, taxDue - amountPaid);
  let paymentStatus;
  if (amountPaid >= taxDue) {
    paymentStatus = 'Paid in Full';
  } else if (amountPaid > 0) {
    paymentStatus = 'Partially Paid';
  } else {
    paymentStatus = statuses[Math.floor(Math.random() * 3) + 2]; // One of the last 3 statuses
  }
  return {
    id: `PROP-${100000 + i}`,
    upi: `${Math.floor(Math.random() * 100)}-${Math.floor(Math.random() * 100)}-${Math.floor(Math.random() * 10000).toString().padStart(4, '0')}`,
    ownerName: `Owner ${i + 1}`,
    propertyType: propertyTypes[Math.floor(Math.random() * propertyTypes.length)],
    jurisdiction: jurisdictions[Math.floor(Math.random() * jurisdictions.length)],
    assessedValue: `$${assessedValue.toLocaleString()}`,
    taxDue: `$${taxDue.toLocaleString()}`,
    amountPaid: `$${amountPaid.toLocaleString()}`,
    outstandingBalance: `$${outstandingBalance.toLocaleString()}`,
    paymentStatus
  };
});